import { Box, Flex, Image } from '@chakra-ui/react';
import {
  loginBanner1,
  loginBanner10,
  loginBanner11,
  loginBanner12,
  loginBanner13,
  loginBanner14,
  loginBanner15,
  loginBanner16,
  loginBanner2,
  loginBanner3,
  loginBanner4,
  loginBanner5,
  loginBanner6,
  loginBanner7,
  loginBanner8,
  loginBanner9,
} from 'assets/images';
import { useEffect, useState } from 'react';
import Form from './Form';

const Login = () => {
  const [selectedImage, setSelectedImage] = useState();

  useEffect(() => {
    const images = [
      loginBanner1,
      loginBanner2,
      loginBanner3,
      loginBanner4,
      loginBanner5,
      loginBanner6,
      loginBanner7,
      loginBanner8,
      loginBanner9,
      loginBanner10,
      loginBanner11,
      loginBanner12,
      loginBanner13,
      loginBanner14,
      loginBanner15,
      loginBanner16,
    ];
    const randomImage = images[Math.floor(Math.random() * images.length)];
    setSelectedImage(randomImage);
  }, []);

  return (
    <Flex h="100vh">
      <Box flex="1" display={{ base: 'none', md: 'block' }}>
        <Image src={selectedImage} fit="cover" w="100%" h="100%" />
      </Box>
      <Box flex="0.5" shadow="rgba(0, 0, 0, 0.35) -5px 0px 15px">
        <Form />
      </Box>
    </Flex>
  );
};

export default Login;
